import { render, staticRenderFns } from "./taskAddDeletePDF.vue?vue&type=template&id=3d9cd45d&"
import script from "./taskAddDeletePDF.vue?vue&type=script&lang=js&"
export * from "./taskAddDeletePDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports